import React, { useState, useEffect } from "react";
import { API_URL } from "../constants";
import axios from "axios";
import { FaEdit, FaTrash } from "react-icons/fa";
import MachineModel from "./MachineModel";
import MachineBrand from "./MachineBrand";
import { UserTypes } from "../constants";

const MachineType = ({ token }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [machineTypes, setMachineTypes] = useState([]);
  const [typeId, setTypeId] = useState("");
  const [machineType, setMachineType] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [newTypeName, setNewTypeName] = useState("");
  const userType = user.type;
  const [isCreatingMaintenance, setIsCreatingMaintenance] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorCreate, setErrorCreate] = useState("");
  const [allMaintenances, setAllMaintenances] = useState([]);
  const [matchingMaintenances, setMatchingMaintenances] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [maintenanceData, setMaintenanceData] = useState({
    nom: "", description: "", typeMachine: { id: `${typeId}` }, heures: 0, freq_intervention: 0, etat: "A_JOUR"
  });

  useEffect(() => {
    axios.get(`${API_URL}/maintenances?limit=1000&offset=0`, {
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` }
    })
      .then(r => setAllMaintenances(r.data.data))
      .catch(console.error);
  }, [token]);

  useEffect(() => {
    if (searchTerm.trim() !== "") {
      const filtered = allMaintenances.filter(m => m.nom.toLowerCase().includes(searchTerm.toLowerCase()));
      setMatchingMaintenances([...new Set(filtered.map(m => m.nom))]);
    } else {
      setMatchingMaintenances([]);
    }
  }, [searchTerm, allMaintenances]);

  useEffect(() => {
    axios.get(`${API_URL}/typesmachine?limit=1000&offset=0`, {
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` }
    })
      .then(r => setMachineTypes(r.data.data))
      .catch(e => console.error("Erreur types machine :", e.message));
  }, [token]);

  useEffect(() => {
    if (!typeId) return;
    axios.get(`${API_URL}/typesmachine/${typeId}`, {
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` }
    })
      .then(r => { setMachineType(r.data); setNewTypeName(r.data.nom); })
      .catch(e => console.error("Erreur type machine :", e.message));
  }, [typeId, token]);

  const handleSaveClick = async () => {
    try {
      const response = await axios.patch(
        `${API_URL}/typesmachine/${typeId}`,
        { nom: newTypeName },
        { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        setEditMode(false);
        setMachineType(prev => ({ ...prev, nom: newTypeName }));
        setMachineTypes(prev => prev.map(mt => mt.id === typeId ? { ...mt, nom: newTypeName } : mt));
        window.location.reload();
      }
    } catch (error) {
      console.error("Erreur mise à jour type machine", error);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`${API_URL}/typesmachine/${typeId}`, {
        headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` }
      });
      setMachineTypes(prev => prev.filter(t => t.id !== typeId));
      setShowDeleteModal(false);
      setTypeId("");
      window.location.reload();
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Erreur lors de la suppression.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "heures" || name === "freq_intervention" ? parseInt(value) : value;
    if (name === "nom") setSearchTerm(newValue);
    setMaintenanceData(prev => ({ ...prev, [name]: newValue }));
  };

  const handleCreateMaintenance = async () => {
    try {
      await axios.post(
        `${API_URL}/maintenances`,
        { nom: maintenanceData.nom, description: maintenanceData.description, typeMachine: { id: `${typeId}` }, heures: parseInt(maintenanceData.freq_intervention), freq_intervention: parseInt(maintenanceData.freq_intervention), etat: "A_JOUR" },
        { headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      );
      setIsCreatingMaintenance(false);
      setMaintenanceData({ nom: "", description: "", typeMachine: { id: `${typeId}` }, heures: 0, freq_intervention: 0, etat: "A_JOUR" });
    } catch (error) {
      const msg = error.response?.data?.message || "Erreur lors de la création.";
      setErrorCreate(msg);
      setTimeout(() => setErrorCreate(""), 3000);
    }
  };

  const inputClass = "w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition";

  return (
    <div className="flex flex-col gap-3">
      <p className="text-xs uppercase tracking-widest text-gray-400 font-semibold">Types de machine</p>

      {/* Sélecteur */}
      <select
        value={typeId || ""}
        onChange={(e) => setTypeId(e.target.value)}
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
      >
        <option value="">Sélectionner un type de machine</option>
        {machineTypes.map(mt => <option key={mt.id} value={mt.id}>{mt.nom}</option>)}
      </select>

      {/* Détail type */}
      {typeId && machineType && (
        <div className="border border-gray-100 rounded-xl p-4 bg-gray-50 flex flex-col gap-3">

          {/* Nom + édition */}
          {editMode ? (
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="text"
                value={newTypeName}
                onChange={(e) => setNewTypeName(e.target.value)}
                className={inputClass}
              />
              <button onClick={handleSaveClick} className="px-4 py-2 bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold rounded-xl transition">
                Valider
              </button>
              <button onClick={() => { setEditMode(false); setNewTypeName(machineType.nom); }} className="px-4 py-2 bg-red-500 hover:bg-red-700 text-white text-sm font-semibold rounded-xl transition">
                Annuler
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <span className="font-bold text-loginBordure text-base">{machineType.nom}</span>
              {(userType === UserTypes.SUPER || userType === UserTypes.ADMIN) && (
                <FaEdit className="cursor-pointer text-gray-400 hover:text-loginBordure transition" onClick={() => setEditMode(true)} />
              )}
            </div>
          )}

          <MachineModel typeId={typeId} token={token} />
          <MachineBrand typeId={typeId} token={token} />

          {/* Bouton créer maintenance */}
          {!isCreatingMaintenance && (
            <button
              onClick={() => setIsCreatingMaintenance(true)}
              className="w-fit text-sm text-loginBordure hover:text-blue-900 font-medium transition flex items-center gap-1"
            >
              + Créer une maintenance pour ce type
            </button>
          )}

          {/* Formulaire création maintenance */}
          {isCreatingMaintenance && (
            <div className="flex flex-col gap-3 pt-3 border-t border-gray-200">
              <p className="text-xs uppercase tracking-widest text-gray-400 font-semibold">Nouvelle maintenance</p>
              <div className="relative">
                <label className="text-xs text-gray-500 mb-1 block">Nom</label>
                <input type="text" name="nom" value={maintenanceData.nom} onChange={handleInputChange} placeholder="Nom de la maintenance" className={inputClass} />
                {matchingMaintenances.length > 0 && (
                  <div className="absolute z-10 w-full top-full mt-1 border border-gray-100 rounded-xl overflow-hidden shadow-md bg-white">
                    {matchingMaintenances.map(name => (
                      <div
                        key={name}
                        onClick={() => {
                          const m = allMaintenances.find(m => m.nom === name);
                          if (m) setMaintenanceData(prev => ({ ...prev, description: m.description, heures: m.heures, freq_intervention: m.freq_intervention, nom: m.nom }));
                          setMatchingMaintenances([]);
                          setSearchTerm("");
                        }}
                        className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-50 border-b border-gray-50 last:border-0 transition"
                      >
                        {name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">Description</label>
                <input type="text" name="description" value={maintenanceData.description} onChange={handleInputChange} placeholder="Description" className={inputClass} />
              </div>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">Fréquence d'intervention (heures)</label>
                <input type="number" name="freq_intervention" value={maintenanceData.freq_intervention} onChange={handleInputChange} className={inputClass} />
              </div>
              {errorCreate && (
                <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-xl px-3 py-2 text-sm font-medium">
                  <span className="w-2 h-2 rounded-full bg-red-500 shrink-0" />
                  {errorCreate}
                </div>
              )}
              <div className="flex gap-2">
                <button onClick={handleCreateMaintenance} className="flex-1 px-4 py-2.5 bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold rounded-xl transition">
                  Valider
                </button>
                <button onClick={() => { setIsCreatingMaintenance(false); setMaintenanceData({ nom: "", description: "", typeMachine: { id: `${typeId}` }, heures: 0, freq_intervention: 0, etat: "A_JOUR" }); }} className="flex-1 px-4 py-2.5 bg-red-500 hover:bg-red-700 text-white text-sm font-semibold rounded-xl transition">
                  Annuler
                </button>
              </div>
            </div>
          )}

          {userType === UserTypes.SUPER && (
            <button onClick={() => setShowDeleteModal(true)} className="flex items-center gap-1.5 text-sm text-red-400 hover:text-red-600 transition w-fit mt-1">
              <FaTrash className="text-xs" />
              Supprimer ce type de machine
            </button>
          )}
        </div>
      )}

      {/* Modal suppression */}
      {showDeleteModal && machineType && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-sm mx-4">
            <p className="text-sm text-gray-600 text-center mb-1">Supprimer le type de machine</p>
            <p className="text-base font-bold text-gray-800 text-center mb-2">{machineType.nom}</p>
            {errorMessage && (
              <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-xl px-3 py-2 text-sm font-medium mb-4">
                <span className="w-2 h-2 rounded-full bg-red-500 shrink-0" />
                {errorMessage}
              </div>
            )}
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowDeleteModal(false)} className="flex-1 px-4 py-2.5 border border-gray-200 text-gray-600 text-sm font-semibold rounded-xl hover:bg-gray-50 transition">
                Annuler
              </button>
              <button onClick={handleConfirmDelete} className="flex-1 px-4 py-2.5 bg-red-500 hover:bg-red-600 text-white text-sm font-semibold rounded-xl transition">
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineType;